import { connect } from 'react-redux';
import { replace } from 'redux-little-router';
import { routeMap } from '../../../router';
import { startRequest as startRequestToGetAdminConfig } from '../redux/adminConfig/actions';
import App from '../components/App';
import { setData } from '../redux/incomingData/actions';
import { showModal } from '../redux/accessibility/actions';
import { createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { property } from 'lodash';
import configTypes from '../../../constants/configObjectTypes';
import { selectRouter } from 'modules/App/utils/selectors';

export default connect(
  createStructuredSelector({
    user: property('app.user'),
    incomingData: property('app.incomingData'),
    router: selectRouter,
    isShowTour: property('app.showTour'),
    isLoggedIn: (state) => {
      const login = property('authorization.login')(state);
      return login.get?.('token');
    },
  }),
  (dispatch) =>
    bindActionCreators(
      {
        setIncomingData: (data) => setData(data),
        clearQueryString: () => replace(routeMap.home),
        goToInfoPage: (query) => replace({ pathname: routeMap.info, query }),
        goToHome: () => replace({ pathname: routeMap.home }),
        showAccessibilityModal: showModal,
        loadModalConfig: () => startRequestToGetAdminConfig(configTypes.modal),
        loadRefConfig: () => startRequestToGetAdminConfig(configTypes.link),
      },
      dispatch,
    ),
)(App);
